<script lang="ts">
  import { slide } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import { BookingForm } from '.';
  import { Modal } from '../components';
  import { Button } from '../elements';
  import { UndoIcon } from '../../components/icons';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let generalSettings: GlobalProperties['generalSettings'];
  export let brand: GlobalProperties['brand'];
  export let borderRadius: GlobalProperties['borderRadius'];
  export let isActive = true;
  export let hasCalendar = false;
  export let email = '';
  export let isCTAMobile = false;

  let submitForm: (event: Partial<FormDataEvent>) => void;
  let isValid = true;
  let form: HTMLFormElement;
  let sent = false;

  const handleSubmit = () => {
    submitForm({ target: form });
  };
</script>

<Modal
  title={hasCalendar ? 'Request your appointment' : 'Get in touch'}
  bind:isActive
>
  <svelte:fragment slot="head">
    {#if hasCalendar && !sent}
      <div
        class="form-banner"
        transition:slide={{ duration: 200, easing: quintOut }}
      >
        <p class="subject">Conversation with {brand.text.value}</p>
      </div>
    {/if}
  </svelte:fragment>
  <BookingForm
    bind:handleSubmit={submitForm}
    bind:form
    bind:sent
    bind:email
    bind:isValid
    {properties}
    {generalSettings}
    {borderRadius}
    {brand}
    {hasCalendar}
    isEmbedded
  />
  <svelte:fragment slot="footer">
    {#if !isCTAMobile}
      {#if sent}
        <Button
          size="small"
          variant="secondary"
          width={160}
          on:click={() => (isActive = false)}
          {borderRadius}
        >
          Close
        </Button>
        <Button
          size="small"
          variant="ghost"
          on:click={() => (sent = false)}
          {borderRadius}
        >
          <UndoIcon />
          Send another request
        </Button>
      {:else}
        <Button
          size="small"
          on:click={handleSubmit}
          disabled={!isValid}
          {borderRadius}
        >
          {#if hasCalendar}
            Request Appointment
          {:else}
            Send message
          {/if}
        </Button>
      {/if}
    {/if}
  </svelte:fragment>
</Modal>

<style>
  .form-banner {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: var(--spacing-small-xl);
    padding: var(--spacing-middle-lg) var(--spacing-middle-lg);
    background-color: var(--fill-fill-light-grey);
  }

  .form-banner .subject {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--text-text-primary);
  }
</style>
